import { Record, type RecordOf } from 'immutable';
import type { UnknownAction } from 'redux';

/**
 * Identifies the operation a deferred undo belongs to. The `undo` meta object of the action that
 * registered the undo serves as the token, because the sagas copy that same object onto the success
 * action, so a completing operation reveals its own entry and never another one's.
 */
export type UndoDeferToken = object;

export interface UndoProps {
  key?: string;
  actions?: UnknownAction[];
  userMessage?: string;
  disableUndoAction?: boolean;
  suppressToast?: boolean;
  toastBottomOffset?: number;
  /**
   * Holds the toast back until revealUndo fires. Set by callers whose write has not finished when
   * the undo is registered — only the pre-edit state can supply the undo, but offering it while
   * requests are still in flight would interleave the revert with the remaining writes.
   */
  deferToast?: boolean;
  /** Set alongside deferToast, and matched against the revealUndo payload. */
  deferToken?: UndoDeferToken;
}

export type Undo = RecordOf<UndoProps>;

export const mkUndo = Record<UndoProps>({
  key: undefined,
  actions: undefined,
  userMessage: undefined,
  disableUndoAction: undefined,
  suppressToast: undefined,
  toastBottomOffset: undefined,
  deferToast: undefined,
  deferToken: undefined,
});
